import { Component } from '@angular/core';
import { breadcrumb, link, stat } from '../../layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  TreeNode,
} from 'primeng/api';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Subject } from 'rxjs/internal/Subject';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import FileSaver from 'file-saver';
import { ExportService } from 'src/app/services/export.service';
import { convert } from 'html-to-text'

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss'],
  providers: [ConfirmationService],
})
export class DataComponent {

  translator: TranslatorPipe = new TranslatorPipe()
  header = this.translate('Data Management');
  links: link[] = [
    {
      name: this.translate('Data classification'),
      icon: 'pi pi-file',
      link: '/admin/data/fields',
      visible: this.linkPermissions('DATA_FIELD')
    },
    {
      name: this.translate('Types of classifications'),
      icon: 'pi pi-file-edit',
      link: '/admin/data/fields/types',
      visible: this.linkPermissions('DATA_FIELD_TYPE')
    },
    {
      name: this.translate('data templates'),
      icon: 'pi pi-plus',
      link: '/admin/data/templates',
      visible: this.linkPermissions('DATA_TEMPLATE')
    },
    {
      name: this.translate('data types'),
      icon: 'pi pi-list',
      link: '/admin/data/types',
      visible: this.linkPermissions('DATA_TYPE')
    },
  ];
  breadcrumbs: breadcrumb[] = [{ name: this.translate('Data Management'), link: '/admin/data' }];
  stats: stat[] = [
    { name: this.translate('active'), number: 0, icon: 'pi pi-check-circle' },
    { name: this.translate('Inactive'), number: 0, icon: 'pi pi-times-circle' },
  ];

  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  skelition: boolean = false;
  skelition2: boolean = false;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ouService: OrgUnitsService,
    public permissionService: PermissionHandlerService,
    private exportService: ExportService,
  ) {


    this.searchSubject.pipe(
      debounceTime(2000), // Adjust the debounce time as needed
      distinctUntilChanged()
    ).subscribe(searchText => {
      this.searchData(searchText);
    });

  }


  data: any;
  filteredData: any = [];
  selectionData: any;
  fieldModal = false;
  fieldData: string = '';
  treeData: any[] = [];
  selectionCopy: any = []
  parentOUS = [
    'الجهات المشاركة',
  ];
  searchText: string = '';
  searchText1: string = '';

  private searchSubject: Subject<string> = new Subject<string>();
  onSearchChange(searchText: any): void {
    this.searchSubject.next(searchText);
  }

  settingModel = false
  settings: any

  activationFilter: boolean = true;

  messages: Message[] = [];
  ouTypes: any;

  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;

  downloadExcel: boolean = false



  ngOnInit() {
    console.log('DATA APIs CALLED', this.permissionService.hasPermission('DATA_BULK', 'a'))
    if (this.permissionService.hasPermission('BULK_EDIT', 'a')) {
      this.skelition = true;
      Promise.all([
        this.fetchFieldType(),
        this.getOuType(),
        this.getTreeData(), this.getSettings()]).then(e => {

          this.typeFilter = this.ouTypes[0].value;

          console.log("this.selectedTreeData", this.selectedTreeData)
          this.oufilter = this.selectedTreeData[0]?.children[0]?.children[0]

          console.log("this.oufilter", this.oufilter)


          this.getData().then(e => {
            this.updateTypeCounts();
            this.skelition = false;
          })
        });
    }





  }



  fieldTypes: any
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  linkPermissions(flag: string) {
    return this.permissionService.hasAnyPermission([{ unit: flag, flag: 'c' }, { unit: flag, flag: 'u' }, { unit: flag, flag: 'd' }]);
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get?offset=1000&page=1', {
      active: true,
    });
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data
  }


  hasUDPermission() {
    return this.permissionService.hasPermission('BULK_EDIT', 'a')
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }


  //Get type of the filed
  getFieldType(type: any) {
    return this.fieldTypes.find((item: any) => item._id == type)?.name
  }



  searchData(query: any) {



    // if (!query) {
    //   this.filteredData = this.data;
    // } else {

    //   let tempData : any = cloneDeep(this.filteredData)
    //   this.filteredData = []
    //   let dataTemp = tempData.filter((d: any) => {
    //     let res = this.searchValue(d, query);
    //     return res;
    //   })

    this.getData()

    //   this.filteredData = cloneDeep(dataTemp)
    console.log("===>this.filteredData")
    // }
  }

  //Service filter function by global
  filterFunctionByPost() {

    console.log(this.oufilter)

    this.skelition2 = true;

    this.getData().then(e => {
      this.updateTypeCounts();
      this.skelition2 = false;
    })

  }

  filterFunctionByPostOuFilter($event: any) {

    console.log("event function", $event);

    this.oufilter = $event.node;

    this.filterFunctionByPost()

  }

  filterFunctionByPostTypeFilter(event: any) {
    console.log("event function", event);

    this.typeFilter = event.value;

    this.filterFunctionByPost()
  }


  //Service filter function by local
  filterFunction() {
    this.filteredData = this.data;
    if (this.typeFilter) {
      this.filteredData = this.filterData(this.data, '_id', this.typeFilter);
    }
    if (this.oufilter) {
      if (this.oufilter.label == 'الجهات المشاركة') {
        this.filteredData = this.data;
        return;
      }
      this.filteredData = this.filterData(this.filteredData, 'id', this.oufilter.id);
    }
    this.filteredData = this.filteredData.filter((obj: any) => { return Object.keys(obj).length >= 8 });
    this.filteredData = this.filteredData.filter((obj: any) => obj.fields && Array.isArray(obj.fields) && obj.fields.length > 0);
    //Updating  the count
    this.updateTypeCounts();
  }


  searchUpdate = new Subject<string>();

  //Refresh to initial state
  refresh() {
    // this.typeFilter = undefined;
    // this.oufilter = undefined;
    this.searchText = ''
    this.filteredData = []
    this.data = []
    this.getData()
  }

  public searchValue(obj: any, targetValue: any): boolean {
    for (const key in obj) {
      const value = obj[key];

      if (value === targetValue) {
        return true;
      }

      if (typeof value == 'string' && value.includes(targetValue)) {
        return true;
      }

      if (typeof value === 'object' && value !== null) {
        if (Array.isArray(value)) {
          for (const item of value) {
            if (this.searchValue(item, targetValue)) {
              return true;
            }
          }
        } else {
          if (this.searchValue(value, targetValue)) {
            return true;
          }
        }
      }
    }

    return false;
  }

  //Function to get common fields of the selected data
  filterData(data: any, key: any, value: any) {
    let results: any = [];

    //Base Recursive Function
    function recursiveFilter(obj: any, parentObj = null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => recursiveFilter(item, parentObj));
      } else if (typeof obj === 'object') {
        if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
          if (parentObj) {
            results.push(parentObj);
          }
          results.push(obj);
        }
        if (obj != null && obj != undefined)
          Object.values(obj).forEach((value) => recursiveFilter(value, obj));
      }
    }

    recursiveFilter(data);
    return results;
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  spinner: boolean = false
  signFilter: any = 'both'
  states: any


  //Getting Initial Data in bulk
  getData = async () => {
    try {
      console.log("OU FILTER", this.oufilter);

      this.data = []
      this.filteredData = []

      this.spinner = true

      let query: any = { active: true, 'tempInactive': !this.activationFilter, "breadcrumbs.id": this.oufilter.id }


      let statesQuery: any = {
        'ous': this.oufilter._id,
      }

      if (this.signFilter == 'signed') {
        query['signed.status'] = true
      } else if (this.signFilter == 'unsigned') query['signed.status'] = false


      if (this.typeFilter) {
        const currenttypeFilter = this.ouTypes.find((item: any) => item.value == this.typeFilter)
        query['type.arabic'] = currenttypeFilter.label
        statesQuery['type.arabic'] = currenttypeFilter.label
      }

      if (this.searchText && this.searchText != '') {
        query.text = this.searchText
      }
      //
      console.log("Activation Status", this.activationFilter)

      let res = await this.dataService.postData('data/data-view', query);

      if (res.error) return




      let states = await this.dataService.postData('data/data-states', statesQuery);


      if (states.error) return

      this.states = states.data



      console.log("===>Query", res.data);
      this.data = res?.data?.filter((e: any) => this.ouService.childrenContainsId(this.treeData, e.ous));
      if (this.searchText1 != '') {
        this.searchText = this.searchText1
      }
      this.filteredData = this.data;
      this.spinner = false
    } catch (error) {
      console.log(error);
    }
  };




  removeSelected(event: any) {
    this.filteredData.unshift(event.data)
    this.selectionData = this.selectionCopy
  }

  getSelected(event: any) {
    this.filteredData = this.filteredData.filter((item: any) => !event.some((selectedItem: any) => selectedItem._id === item._id));
    this.selectionCopy = this.selectionData
  }


  selectAllData() {
    this.selectionData = [...this.selectionData, ...this.filteredData]
    this.selectionCopy = [...this.selectionData, ...this.filteredData]
    this.filteredData = []
  }

  unselectAllData() {
    this.selectionData
    this.filteredData = [...this.selectionData, ...this.filteredData]
    this.selectionData = []
    this.selectionCopy = []
  }

  //Get Ou types
  getSettings = async () => {
    try {
      let res = await this.dataService.postData('settings/get?offset=1000&page=1', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.settings = res.data[0]
      console.log("Settings ==>", this.settings);
    } catch (error) {
      console.log(error);
    }
  };

  async upDateSetting() {
    try {
      let res = await this.dataService.postData('settings/', { _id: this.settings._id, sign_duration: this.settings.sign_duration }, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.settingModel = false
    } catch (error) {
      console.log(error);
    }
  };


  //Get Ou types
  getOuType = async () => {
    try {
      let res = await this.dataService.postData('data-type/get?offset=1000&page=1', {
        active: true,
      });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      let allowedTypes = this.permissionService.extractTags('CONTENT_UPDATE_DATA_TYPE','r');

      this.ouTypes = res.data
      .filter((item: any) => allowedTypes.includes(item._id))
      .map((item: any) => {
        return {
          label: item.arabic,
          value: item._id,
          icon: item.icon,
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  commonFields: any = [];
  updateModal = false;

  reasonModal: any = false
  reasonHolder: any = undefined
  reasonError: boolean = false

  updateData() {

    this.reasonHolder = undefined

    this.commonFields = cloneDeep(this.findCommonFieldObjects(this.selectionData));
    console.log('selectionData =>', this.selectionData, this.commonFields);
    this.commonFields.forEach((item: any) => {
      item.data = '';
    });

    for (let i = 0; i < this.commonFields.length; i++) {
      this.commonFields[i].isChecked = false;
    }

    this.updateModal = true;

    for (let i = 0; i < this.selectionData.fields.length; i++) {
      this.commonFields[i].isChecked = false;
    }


  }

  updateOUModal = false
  assignOU: any

  //update ou of Data
  async updateDataOU() {



    if (this.selectionData.length <= 0) return


    let breadcrumb: any = [];
    let tempAtter = { ...this.assignOU }
    let depth = 0
    while (tempAtter.parent != undefined) {
      breadcrumb.push({
        label: tempAtter.label,
        _id: tempAtter._id,
        id: tempAtter.id,
        icon: tempAtter.data,
        depth: depth,
        routerLink: '/category/' + tempAtter.id
      })
      tempAtter = tempAtter.parent
      depth++
    }

    console.log("this.assignOU==>", this.assignOU, breadcrumb);


    this.skelition = true;
    this.selectionData.forEach(async (item: any) => {
      let updateLog = {
        status: 'PENDING',
        type: 'OU CHANGE',
        data_type: item.type._id,
        before: {
          name: item.name,
          dataview: item
        },
        after: {
          newOu: {
            _id: this.assignOU._id,
            breadcrumb: breadcrumb
          }
        },
        ous: item.ous,
        service_id: item._id
      }

      this.editContent(updateLog)

    })
    this.messages = [
      { severity: 'success', summary: this.translate('success') },
    ];
    this.selectionData = [];
    let response = await this.dataService.getData('ou/clean');

    this.getData().then(e => {
      this.updateTypeCounts();
      this.skelition = false;
    })


    this.updateOUModal = false



  }



  //Edit Content request
  async editContent(data: any, multi: boolean = false) {
    try {

      this.spinner = true

      console.log("Data Edit Called ==>", data)

      let url = 'content-update/'

      if (multi) {
        url = 'content-update/multiple-request'
      }

      let res = await this.dataService.postData(url, data);

      //return if error detected 
      if (res.error) {
        return;
      }

      if (multi) {

        for (let i = 0; i < res.data.length; i++) {
          let isOuPermission: boolean = await this.permissionService.checkOUPermissionByID('CONTENT_UPDATE_LOGS', 'r', res.data[i].ous)
          if (this.permissionService.hasPermission('CONTENT_APPROVE', 'a') && isOuPermission) {
            //Auto Approving data
            res.data[i].status = 'APPROVED'
            delete res.data[i].adminChange
            delete res.data[i].createdAt
            delete res.data[i].updatedAt
            delete res.data[i].__v
            let res2 = await this.dataService.postData('content-update/approve', res.data[i], 'PUT', false);
            if (res2.error) {
              this.messages = [
                { severity: 'error', summary: this.translate('error'), detail: res.msg },
              ];
              return
            }
          }
        }
      }
      else {
        let isOuPermission: boolean = await this.permissionService.checkOUPermissionByID('CONTENT_UPDATE_LOGS', 'r', data.ous)
        if (this.permissionService.hasPermission('CONTENT_APPROVE', 'a') && isOuPermission) {
          //Auto Approving data
          data._id = res.data._id
          data.status = 'APPROVED'
          let res2 = await this.dataService.postData('content-update/approve', data, 'PUT', false);
          if (res2.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return
          }
        }
      }

      this.spinner = false

      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }


  //Handling Update Logs
  sendUpdateLogs() {

    this.reasonError = false

    if (!this.reasonHolder) {
      this.reasonError = true
      return
    }


    let getUpdatedFields = this.commonFields.filter(
      (item: any) => item.isChecked == true
    );
    for (let i = 0; i < this.selectionData.length; i++) {
      // Create a mapping of _id to objects in the trueArray for efficient lookup
      const trueArrayMap: any = new Map(getUpdatedFields.map((obj: any) => [obj.field._id, obj]));

      // Update objects in the falseArray with corresponding objects from the trueArray
      const updatedFalseArray = this.selectionData[i].fields.map((obj: any) => {
        if (trueArrayMap.has(obj.field._id)) {
          return { ...trueArrayMap.get(obj.field._id) };
        }
        return obj;
      });

      let updateLog = {
        status: 'PENDING',
        type: 'EDIT',
        data_type: this.selectionData[i].type._id,
        before: {
          name: this.selectionData[i].name,
          dataview: this.selectionData[i]
        },
        after: {
          name: this.selectionData[i].name,
          fields: updatedFalseArray

        },
        ous: this.selectionData[i].ous,
        service_id: this.selectionData[i]._id,
        reason: this.reasonHolder
      }

      this.editContent(updateLog);
    }


    // let updateLog = {
    //   status: 'PENDING',
    //   type: 'EDIT',
    //   data_type: this.previousView.type._id,
    //   before: {
    //     name: this.previousView.name,
    //     dataview : this.previousView
    //   },
    //   after: {
    //     name: this.currentview.name,
    //     fields: this.currentview.fields

    //   },
    //   ous: this.currentview.ous,
    //   service_id: this.currentview._id
    // }

    // getUpdatedFields.forEach((field: any) => {
    //   //iterate through selected data
    //   this.selectionData.forEach((item: any) => {
    //     //Retrieving Old Data
    //     let previousData = item.fields.filter((e: any) => {
    //       return e.field._id == field.field._id;
    //     })[0]?.data
    //     //creating log
    //     let updateLog = {
    //       status: 'PENDING',
    //       type: 'EDIT',
    //       before: {
    //         'field.type': field.field._id,
    //         data: previousData,
    //       },
    //       after: {
    //         'field.type': field.field._id,
    //         data: field.data,
    //       },
    //       ous: item.ous,
    //       service_id: item._id,
    //     };
    //     this.editContent(updateLog);
    //     this.messages = [
    //       { severity: 'success', summary: this.translate('success'), detail: 'Updates Send' },
    //     ];
    //   });
    // });

    this.updateModal = false;
    this.selectionData = [];
    this.messageService.add({
      key: 'myKey',
      severity: 'success',
      summary: 'Message 1',
      detail: 'Update Request Send Successfully',
    });

    // this.ngOnInit()
  }



  // Function to find  common filed in the object
  findCommonFieldObjects(data: any) {
    let firstObj = { ...data[0] },
      commonObjects: any = [];

    // If only one Data Is Selected
    if (data.length <= 1) {
      return firstObj.fields
    }

    //compairing data and taking out common fields
    for (let found of firstObj.fields) {
      console.log(' test found', found);

      let level1Check = false;

      for (let i = 1; i < data.length; i++) {
        let level2Check = false;
        for (let filed of data[i].fields) {
          if (filed.label._id == found.label._id) {
            level2Check = true;
            break;
          }
        }
        if (level2Check == true) {
          level1Check = true;
        } else {
          level1Check = false;
          break;
        }
      }
      if (level1Check == true) {
        commonObjects.push(found);
      }
    }

    console.log('==>', commonObjects);

    return commonObjects;
  }


  confirmInactiveService(status: boolean) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.inactiveService(status),
    });
  }






  //Function call for signing Services
  async inactiveService(status: boolean) {
    try {


      let arrayOfIds = this.selectionData.map((item: any) => item._id)

      let data: any = {
        data: arrayOfIds,
        status: status
      }

      console.log("===>", data);


      let res = await this.dataService.postData('data/temp-inactive', data, 'PUT', false);
      // return if error detected 
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }



      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      //calling Ou clean
      let ous = this.getUniqueOus(this.selectionData)
      await this.cleanOu(ous)

      this.selectionData = []
      this.getData()


    } catch (error) {
      console.log(error)
    }
  }


  confirmSignService(flag = true) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.signServices(flag),
    });
  }




  //Function call for signing Service
  async signServices(flag: boolean) {
    try {
      let user_id = localStorage.getItem('uid')
      let user_name = localStorage.getItem('username')

      let signServiceObject: any = []
      this.selectionData.forEach((item: any) => {
        signServiceObject.push({
          _id: item._id,
          ou: item.ous,
          signed: {
            status: flag,
            user_id: user_id,
            user_name: user_name
          }
        })
      })

      let res = await this.dataService.postData('data/sign-data', { data: signServiceObject }, 'PUT', false);
      //return if error detected 
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      //calling Ou clean
      let ous = this.getUniqueOus(this.selectionData)


      await this.cleanOu(ous)


      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      this.selectionData = []
      this.getData()

    } catch (error) {
      console.log(error)
    }
  }


  getUniqueOus(items: any) {
    const ouValues = items.map((item: any) => item.ous);
    return [...new Set(ouValues)];
  }

  async cleanOu(ous: any) {
    try {

      let res = await this.dataService.postData('data/ou-clean', ous)
      if (res.error) return false
      return true
    } catch (error) {
      return error
    }
  }


  confirmDeleteService() {

    this.reasonError = false

    if (!this.reasonHolder) {
      this.reasonError = true
      return
    }

    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteService(),
    });
  }

  async deleteService() {
    let deleteRequests: any = []
    this.selectionData.forEach((item: any) => {
      let daleteLog = {
        status: 'PENDING',
        type: 'DELETE',
        ous: item.ous,
        before: {
          name: item.name,
          dataview: item
        },
        service_id: item._id,
        data_type: item.type._id,
        updated_by: localStorage.getItem('uid'),
        reason: this.reasonHolder
      };
      // this.editContent(daleteLog , false);
      deleteRequests.push(daleteLog)
    });
    this.editContent(deleteRequests, true);
    console.log("==>test delete", deleteRequests)
    this.selectionData = [];
    this.reasonModal = false
    let response = await this.dataService.getData('ou/clean');
    this.messageService.add({
      key: 'myKey',
      severity: 'success',
      summary: 'Message 1',
      detail: 'Delete Request Send Successfully',
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    if (this.typeFilter || this.oufilter || this.filteredData) {
      let activeCount = this.filteredData.filter((e: any) => e.active === true).length;
      let inactiveCount = this.filteredData.length - activeCount;
      this.stats = [
        { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
        { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
      ];
    }
  }


  sortFiled(fileds: any): Array<any> {
    return fileds?.sort((a: any, b: any) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });
  }


  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem
    this.toggleModal(index)
  }




  // async getTreeData() {
  //   let data : any= await await this.orgUnits.getOrgUnits()
  //   this.selectedTreeData = []

  //   //get weekly type
  //   // let selectedid : any = this.trainingTypes.find((e:any)=>e.name == 'New Branch').allowed_ou


  //   if (selectedid.label != 'الجهات المشاركة') {

  //     this.selectedTreeData.push(this.findNodeByName(data, selectedid._id))
  //     // Create a deep copy of the selected data using lodash.clonedeep
  //     this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
  //     console.log("the selected tree 109", this.selectedTreeData);

  //     const uniqueTags = new Set()

  //     this.types.forEach((type: any) => {
  //       if (type && type.tag) {
  //         uniqueTags.add(type.tag);
  //       }
  //     });

  //     let uniqueTagsArray: MenuItem[] = []

  //     uniqueTags.forEach((item: any) => {
  //       if (item != "Ministries/Entities")
  //         uniqueTagsArray.push({ label: item });
  //     })

  //     this.selectedTreeTags = uniqueTagsArray;

  //     this.selectedTreeTags_current = this.selectedTreeTags[0]

  //     this.changeSelectedTag(this.selectedTreeTags_current);

  //     console.log("====>Selected Tree Data",this.selectedTreeData , uniqueTagsArray);


  //   }

  // }

  //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('BULK_EDIT', 'a');

    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);

    console.log("===>test data d", this.selectedTreeData);
  }


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      // if (node._id === nodeName) {
      //   return node;
      // }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Content Related"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event, this.selectedTreeData);
      await this.filterTreeByTag("Content Related");
    } else {
      this.selectedTreeData = null;
    }

  }


  selectedTreeData: any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }



  getGreatestDepthIcon(items: any): string {
    if (items.length === 0) return 'null';

    let maxDepth = -1;
    let icon: string = '';

    items.breadcrumbs.forEach((item: any) => {
      if (item.depth > maxDepth) {
        maxDepth = item.depth;
        icon = item.icon;
      }
    });

    return icon;
  }


  //EXPORT

  public async getExportData() {
    try {
      let query: any = { active: true, 'tempInactive': !this.activationFilter, "breadcrumbs.id": this.oufilter.id }


      let statesQuery: any = {
        'ous': this.oufilter._id,
      }

      if (this.signFilter == 'signed') {
        query['signed.status'] = true
      } else if (this.signFilter == 'unsigned') query['signed.status'] = false


      if (this.typeFilter) {
        const currenttypeFilter = this.ouTypes.find((item: any) => item.value == this.typeFilter)
        query['type.arabic'] = currenttypeFilter.label
        statesQuery['type.arabic'] = currenttypeFilter.label
      }

      if (this.searchText && this.searchText != '') {
        query.text = this.searchText
      }
      //
      console.log("Activation Status", this.activationFilter)

      let res = await this.dataService.postData('data/data-view-export', query);

      if (res.error) return

      return res.data

    } catch (error) {
      console.log(error)
    }
  }


  public async exportExcel() {
    this.downloadExcel = true
    let cleanData: any = await this.getExportData()

    const stripHtmlTags = (str: any) => {
      return str.replace(/<\/?[^>]+(>|$)/g, "");
    };

    const convertHtmlToText = (html: string) => {
      return convert(html, {
          wordwrap: 130, // Preserve formatting width
          preserveNewlines: true, // Keeps new lines and spacing
      });
    };

    const updatedDataArray = cleanData.map((item: any) => {
      const fieldsWithoutHtml: any = {};

      // Remove HTML tags from fields values
      for (let key in item.fields) {
        if (item.fields.hasOwnProperty(key)) {
          fieldsWithoutHtml[key] = convertHtmlToText(item.fields[key]);
        }
      }

      console.log("with html", item.fields)
      console.log("without html", fieldsWithoutHtml)

      // Spread the properties of the `fields` object into the parent object
      return {
        ...item,
        ...fieldsWithoutHtml
      };
    });

    // Remove the `fields` property from each object
    updatedDataArray.forEach((item: any) => {
      delete item.fields;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray);
    this.downloadExcel = false
  }




}
